export function joinClassNames(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}

export function createTextList(items: readonly string[]): readonly string[] {
  return items.filter((item) => item.trim().length > 0);
}
